<template>
    <div :class="{'share-container': true, on: isPhone}">
        <div v-show="!isPhone" class="pc">
            <div v-if="info && info.expire_at" class="time">该素材将于{{info.expire_at}}失效</div>
                <img class="logo" :src="$_syscfg.product_logo" alt="logo">
                <div v-show="encrypt" class="file-container">
                    <div v-if="!isTimeOut" class="title">{{auth.truename}}分享了1个文件</div>
                    <div v-if="!isTimeOut" class="content">
                        <span class="notice">请输入提取码</span>
                        <div class="input-container">
                            <div class="input">
                                <input v-model="password" type="text">
                            </div>
                            <p @click="getDetail" class="btn">提取文件</p>
                        </div>
                        <span v-show="isError" class="alert">提取码错误</span>
                    </div>
                    <div v-if="isTimeOut" class="error-container">
                        <div class="left"></div>
                        <div class="right">
                            <p class="title">糟糕！你所访问的页面不存在了</p>
                            <div class="content">
                                <span>可能的原因：</span>
                                <p>1.地址栏中输入的地址有错误</p>
                                <p>2.分享的链接已过期</p>
                            </div>
                            <p @click="toHome" class="href">回到网站首页></p>
                        </div>
                    </div>
                </div>
                <div v-show="!encrypt" class="detail-container">
                    <div class="title">
                        <img :src="info.avatar" alt="">
                        <p>{{info.truename}}分享了1个文件</p>
                    </div>
                    <p class="line"></p>
                    <div class="content">
                        <p :title="info.title">{{info.title}}</p>
                        <div class="media">
                            <div v-if="info.type-0 === 1" :style="'background-image: url('+info.url+');'" class="pic"></div>
                            <div v-if="info.type-0 === 2" class="video">
                                <div class="speedRate">
                                    <div @click="showSelectList=!showSelectList" class="btn">
                                        <span>{{nowSpeed}}</span>
                                        <img src="@assets/img/material/whiteArrow.svg" alt="">
                                    </div>
                                    <div v-if="showSelectList" class="btnList">
                                        <p></p>
                                        <ul>
                                        <li @click="changeSpeed('1x')">1x</li>
                                        <li @click="changeSpeed('2x')">2x</li>
                                        <li @click="changeSpeed('4x')">4x</li>
                                        </ul>
                                    </div>
                                </div>
                                <video ref="videoDom" controls controlsList="nodownload" contextmenu="none" :src="info.url" :poster="info.cover"></video>
                            </div>
                            <div v-show="info.type-0 === 3" class="audio">
                                <audio ref="audioDom" preload="load" :src="info.url"></audio>
                                <div class="control">
                                    <img class="disk" src="@assets/img/material/disk.png" alt="">
                                    <img @click="audioPlay" v-if="isPlay === false" class="play" src="@assets/img/material/playIcon.svg" alt="">
                                    <img @click="audioPause" v-if="isPlay" class="pause" src="@assets/img/material/pauseIcon.svg" alt="">
                                </div>
                                <div class="progress-container">
                                    <div class="time">
                                        <span>{{nowTime}}</span>
                                        <span class="grey">/{{endTime}}</span>
                                    </div>
                                    <div ref="line" class="progress">
                                        <p @click="isMouseClick=true;clickJump($event)" class="progress-bg"></p>
                                        <p @click="isMouseClick=true;clickJump($event)" class="progress-fill" :style="'width:' + audioPercent">
                                        <i @mouseenter.prevent="isMouseClick=false" @mouseout.prevent="timeNavi();isMouseClick=false;" @mousedown.prevent="isMouseClick=true;timeStop();isPlayAudio=false" @mouseup.prevent="timeNavi();isMouseClick=false;"
                                            @mousemove.prevent="slideMouseMove"></i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <img v-if="info.type-0 === 1" class="preview" @click="openViewer" src="../../assets/img/share/preview.png" alt="">
                        </div>
                    </div>
                    <div class="btns">
                        <div v-if="info.type != 2 && isLogin" @click="download">
                            <img src="../../assets/img/share/download.png" alt="">
                            <span>下载（{{info.size}}）</span>
                        </div>
                        <div v-if="info.type == 2 && isLogin" @click="showDownload = !showDownload">
                            <img src="../../assets/img/share/download.png" alt="">
                            <span>下载（{{info.size}}）</span>
                            <ul v-show="showDownload">
                                <li @click="downloadSource(info,0)" v-if="info.has_low_quality_download_role" class="k">
                                    <i></i>
                                    <p>800K码流</p>
                                </li>
                                <li @click="downloadSource(info,2)" v-if="info.has_publish_quality_download_role" class="k">
                                    <i></i>
                                    <p>发布码流</p>
                                </li>
                                <li @click="downloadSource(info,1)" v-if="info.has_high_quality_download_role" class="hd">
                                    <i></i>
                                    <p>原始码流</p>
                                </li>
                            </ul>
                        </div>
                        <div  v-click-outside="closeCreate" v-if="info.material || info.report || info.publish" @click="showCreate = !showCreate" class="green">
                            <img src="../../assets/img/share/create.png" alt="">
                            <span>创建</span>
                            <ul v-if="showCreate">
                                <li v-show="info.material" @click="navigate('material',info.id)" class="clue">
                                    <i></i>
                                    <p>上传线索</p>
                                </li>
                                <li v-show="info.report" @click="navigate('report',info.id)" class="report">
                                    <i></i>
                                    <p>创建报道</p>
                                </li>
                                <li v-show="info.publish" @click="navigate('publish',info.id)" class="publish">
                                    <i></i>
                                    <p>创建发布</p>
                                </li>
                                <li v-show="info.newMedia" @click="navigate('new_media',info.id)" class="newMediaPublic">
                                    <i></i>
                                    <p>新媒体发布</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <p class="statement">
                    SMT RDC 提供技术支持
                </p>
        </div>
        <div class="mob" v-show="isPhone">
            <div v-if="encrypt && !isTimeOut" class="head">
                <img :src="auth.avatar" alt="">
                <p>{{auth.truename}}</p>
            </div>
            <div v-if="encrypt && !isTimeOut" class="input">
                <input v-model="password" placeholder="请输入提取码" type="text">
            </div>
            <div v-if="encrypt && !isTimeOut" @click="getDetail" class="btn">提取文件</div>
            <div v-if="isTimeOut" class="err-container">
                <div class="left"></div>
                <div class="right">
                    <p class="title">糟糕！你所访问的页面不存在了</p>
                    <div class="content">
                        <span>可能的原因：</span>
                        <p>1.地址栏中输入的地址有错误</p>
                        <p>2.分享的链接已过期</p>
                    </div>
                    <p @click="toApp" class="href">回到APP首页>></p>
                </div>
            </div>
            <div v-if="!encrypt && !isTimeOut" class="content">
                <div class="detail">
                    <div class="head">
                        <img :src="info.avatar" alt="">
                        <p>{{info.truename}}分享了1个文件</p>
                    </div>
                    <div class="line"></div>
                    <div class="title">
                        {{info.title}}
                    </div>
                    <div class="media">
                        <div v-if="info.type-0 === 1" :style="'background-image: url('+info.url+');'" class="pic"></div>
                            <div v-if="info.type-0 === 2" class="video">
                                <div class="speedRate">
                                    <div @click="showSelectList=!showSelectList" class="btn">
                                        <span>{{nowSpeed}}</span>
                                        <img src="@assets/img/material/whiteArrow.svg" alt="">
                                    </div>
                                    <div v-if="showSelectList" class="btnList">
                                        <p></p>
                                        <ul>
                                        <li @click="changeSpeed('1x')">1x</li>
                                        <li @click="changeSpeed('2x')">2x</li>
                                        <li @click="changeSpeed('4x')">4x</li>
                                        </ul>
                                    </div>
                                </div>
                                <video ref="videoDom" controls controlsList="nodownload" contextmenu="none" :src="info.url" :poster="info.cover"></video>
                            </div>
                            <div v-show="info.type-0 === 3" class="audio">
                                <audio ref="audioDom" preload="load" :src="info.url"></audio>
                                <div class="control">
                                    <img class="disk" src="@assets/img/material/disk.png" alt="">
                                    <img @click="audioPlay" v-if="isPlay === false" class="play" src="@assets/img/material/playIcon.svg" alt="">
                                    <img @click="audioPause" v-if="isPlay" class="pause" src="@assets/img/material/pauseIcon.svg" alt="">
                                </div>
                                <div class="progress-container">
                                    <div class="time">
                                        <span>{{nowTime}}</span>
                                        <span class="grey">/{{endTime}}</span>
                                    </div>
                                    <div ref="line" class="progress">
                                        <p @click="isMouseClick=true;clickJump($event)" class="progress-bg"></p>
                                        <p @click="isMouseClick=true;clickJump($event)" class="progress-fill" :style="'width:' + audioPercent">
                                        <i @mouseenter.prevent="isMouseClick=false" @mouseout.prevent="timeNavi();isMouseClick=false;" @mousedown.prevent="isMouseClick=true;timeStop();isPlayAudio=false" @mouseup.prevent="timeNavi();isMouseClick=false;"
                                            @mousemove.prevent="slideMouseMove"></i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <img v-if="info.type-0 === 1" class="preview" @click="openViewer" src="../../assets/img/share/preview.png" alt="">
                    </div>
                    <div v-show="isLogin" class="btns">
                        <p>下载({{info.size}})</p>
                        <div>
                            <p @click="showCreate = true" class="green">创建</p>

                            <ul v-if="showCreate">
                                <li v-show="info.material" @click="navigate('material',info.id)" class="clue">
                                    <i></i>
                                    <p>上传线索</p>
                                </li>
                                <li v-show="info.report" @click="navigate('report',info.id)" class="report">
                                    <i></i>
                                    <p>创建报道</p>
                                </li>
                                <li v-show="info.publish" @click="navigate('publish',info.id)" class="publish">
                                    <i></i>
                                    <p>创建发布</p>
                                </li>
                                <li v-show="info.newMedia" @click="navigate('new_media',info.id)" class="newMediaPublic">
                                    <i></i>
                                    <p>新媒体发布</p>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
                    <div v-if="info && info.expire_at" class="time1">该素材将于{{info.expire_at}}失效</div>
                </div>
            </div>

            
        </div>
    </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import vClickOutside from "v-click-outside";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    data() {
        return {
            isError: false,
            isTimeOut: false,
            idstring: '',
            encrypt: false,
            password: '',
            info: {},
            auth: {},
            showCreate: false,
            showSelectList: false,
            nowSpeed: '1x',
            showDownload: false,
            isPlay: false,
            nowTime: "00:00:00",
            endTime: "00:00:00",
            duration: 0,
            percent: 0,
            audioPercent: "0%",
            isMouseClick: false,
            isLogin: false,
            isPhone: false,
            fontSize: 100
        }
    },
    methods: {
        audioPlay(){
        this.$refs.audioDom.play();
        this.isPlay=true;
        },
        audioPause(){
        console.log(99999)
        this.$refs.audioDom.pause();
        this.isPlay=false;
        },
        clickJump(e) {
        let clientX = this.$refs.line.getBoundingClientRect().x;
        let width = this.$refs.line.getBoundingClientRect().width;
        let left = 0;
        let percent = 0;

        if (e.clientX - clientX <= 0) {
            left = "0%";
        } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
            left = "100%";
        } else {
            percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
            left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
        }

        this.percent = percent;
        this.audioPercent = left;

        // this.$refs.sliderLeft.style.width = left;

        this.timeNavi();

        this.isMouseClick = false;
        },
        timeNavi() {
        if (this.isMouseClick) {
            let percent = this.percent / 100;
            let time = (percent * this.duration).toFixed(2);
            this.$refs.audioDom.currentTime = time;
            this.$refs.audioDom.play();
            this.isPlay = true;
            this.isMouseClick = false;
        }
        },
        timeStop() {
        this.isPlay = false;
        this.$refs.audioDom.pause();
        },
        slideMouseMove(e) {
        // return false;
        if (this.isMouseClick) {
            let clientX = this.$refs.line.getBoundingClientRect().x;
            let width = this.$refs.line.getBoundingClientRect().width;
            let left = 0;
            let percent = 0;

            if (e.clientX - clientX <= 0) {
            left = "0%";
            } else if (e.clientX - clientX >= this.$refs.line.getBoundingClientRect().width) {
            left = "100%";
            } else {
            percent = (((e.clientX - clientX) / width) * 100).toFixed(2);
            left = (((e.clientX - clientX) / width) * 100).toFixed(2) + "%";
            }

            this.nowTime = this.s2hms(
            (this.$refs.audioDom.duration * percent) / 100
            );

            this.percent = percent;
            this.audioPercent = left;

            // this.$refs.sliderLeft.style.width = left;
        }
        },
        s2hms(time) {
        var min = Math.floor(time % 3600);
        var hh =
            Math.floor(time / 3600) < 10
            ? "0" + Math.floor(time / 3600)
            : Math.floor(time / 3600);
        var mm =
            Math.floor(min / 60) < 10
            ? "0" + Math.floor(min / 60)
            : Math.floor(min / 60);
        var ss = time % 60 < 10 ? "0" + parseInt(time % 60) : parseInt(time % 60);
        return hh + ":" + mm + ":" + ss;
        // console.log(hh + ":" + mm + ":"+ ss)
        },
        audioLoad() {
        let that = this;
        that.duration = parseInt(that.$refs.audioDom.duration);
        that.endTime = that.s2hms(parseInt(that.$refs.audioDom.duration));
        console.log(that.$refs.audioDom.duration,that.endTime)
        if(isNaN(that.$refs.audioDom.duration)){
            that.endTime = '00:00:00'
        }
        that.nowTime = that.s2hms(parseInt(that.$refs.audioDom.currentTime));
        if(isNaN(that.nowTime)){
            that.nowTime = '00:00:00'
        }
        var percent =
            (
            (parseInt(that.$refs.audioDom.currentTime) /
                parseInt(that.$refs.audioDom.duration)) *
            100
            ).toFixed(2) + "%";
        that.audioPercent = percent;

        // this.$refs.audioDom.play();
        // this.isPlay = true;

        this.$refs.audioDom.ontimeupdate = function (e) {
            that.nowTime = that.s2hms(parseInt(e.target.currentTime));
            let percent =
            (
                (parseInt(e.target.currentTime) / parseInt(e.target.duration)) *
                100
            ).toFixed(2) + "%";
            that.audioPercent = percent;
        };

        this.$refs.audioDom.onended = function () {
            that.isPlay = false;
        };
        },
        downloadSource(source, type) {
            if (type === 0) {
                if (!this.info.has_low_quality_download_role) {
                    this.$toast("无下载权限");
                    return;
                } else {
                
                }
            } else if (type === 1) {
                if(this.info.type == 1){
                if (!this.info.has_high_quality_download_role&&!this.info.has_low_quality_download_role) {
                    this.$toast("无下载权限");
                    return;
                }
                }else if(this.info.type == 3) {
                if (!this.info.has_high_quality_download_role&&!this.info.has_low_quality_download_role) {
                    this.$toast("无下载权限");
                    return;
                }
                }else{
                if (!this.info.has_high_quality_download_role) {
                    this.$toast("无下载权限");
                    return;
                }
                }
            }

            if(this.isStream){
                const info = {
                id: source.id,
                type: this.detail.type || 0
                };

                const url = apis.streammediaDownload;
                const userKeys = common.userKeys();
                const params = Object.assign({}, info, userKeys);

                common.myFetch(url, params).then(r => {
                if (r) {
                    // console.log(r)

                    var link,evt;
                
                    link = document.createElement('a');
                    link.href = r.download_url;
                    link.setAttribute('download', '');
                    if(document.fireEvent) {
                        window.open(link.href);
                    }else {
                        evt = document.createEvent('MouseEvents');
                        evt.initEvent('click', true, true);
                        link.dispatchEvent(evt);
                    }
                }
                });

                // console.log(params)
            }else{
                const info = {
                idstring: source.id,
                file_quality: type || 0
                // subject_type: 0,
                // subject_id: this.$route.query.d
                };
                const url = apis.File_download;
                const userKeys = common.userKeys();
                const params = Object.assign({}, info, userKeys);

                common.exportRes(url, params, 1);
            }

        },
        changeSpeed(speed) {
            const video = this.$refs.videoDom;
            this.nowSpeed = speed;
            let multiple = 1;
            if (speed === "1x") {
                multiple = 1;
            } else if (speed === "2x") {
                multiple = 2;
            } else {
                multiple = 4;
            }
            video.playbackRate = multiple;
            this.showSelectList = false;
        },
        closeCreate() {
            this.showCreate = false;
        },
        async navigate(type, id) {
            if (type === "material") {
            let info = {
            id: id,
            push_to: type,
            type: 0
            };
            common.myFetch(apis.File_filepush, {method: 'post', needLogin: false, data: info}).then(r => {
            if (r) {
                common.jump(`/creatClue?t=0&d=${r.id}`, true);
            }
            });
        } else if (type === "report") {
            const typeName = await this.$pageType();
            if (!typeName) return;
            let info = {
            id: id,
            push_to: type,
            type: typeName
            };
            common.myFetch(apis.File_filepush, {method: 'post', needLogin: false, data: info}).then(r => {
            if (r) {
                common.jump(`/creatReport?t=${typeName}&d=${r.id}`, true);
            }
            });
        } else if (type === "publish") {
            const typeName = await this.$pageType("publish");
            if (!typeName) return;
            let info = {
            id: id,
            push_to: type,
            type: typeName
            };
            common.myFetch(apis.File_filepush, {method: 'post', needLogin: false, data: info}).then(r => {
            if (r) {
                common.jump(`/createPublish?t=${typeName}&d=${r.id}`, true);
            }
            });
        } else if (type === "new_media") {
            const typeName = await this.$MediaPlatform();
            if (!typeName) return;
            let info = {
                file_ids: id,
                subject_type: 5,
                subject_id: typeName
            };
            common.myFetch(apis.File_bind, info).then(r => {
            if (r) {
                common.jump(`/createMediaPublish?d=${typeName}`, true);
            }
            });
        }
        },
        openViewer() {
            // this.openViewer(videos, {url: i.src, downloadUrl: i.src, idstring: ''}, 'video')
            let type = this.info.type == 1 ? 'img' : this.info.type == 2 ? 'video' : 'audio'
            this.$viewer([], {url: this.info.url, downloadUrl: this.info.url, idstring: '', type: this.info.type-0}, type)
        },
        checkEncrypr() {
            const info = {
                idstring: this.idstring
            };

            common.myFetch(apis.fileCheck, {method: 'post', needLogin: false, data: info}).then(res => {
                if (res) {
                    console.log(res)
                    this.auth = res
                    this.encrypt = res.encrypt
                    this.isTimeOut = false
                    if(!res.encrypt){
                        this.getDetail()
                    }
                }else{
                    this.isTimeOut = true
                    this.encrypt = true
                }
            });
        },
        getDetail() {
            const info = {
                idstring: this.idstring,
                password: this.password
            };

            common.myFetch(apis.fileDetail, {method: 'post', needLogin: false, data: info}).then(res => {
                if (res) {
                    console.log(res)
                    this.encrypt = false
                    this.info = res
                    this.isError = false

                    if(res.type == 3){
                        setTimeout(() => {
                            this.audioLoad()
                        }, 1000);
                    }
                }else{
                    this.isError = true
                }
            });
        },
        download() {
            const info = {
                idstring: this.info.id,
                file_quality: 0
            };
            const url = apis.File_download;
            const userKeys = common.userKeys();
            const params = Object.assign({}, info, userKeys);

            common.exportRes(url, params, 1);
        },
        recalc() {
            var clientWidth = document.documentElement.clientWidth;

            if (!clientWidth) {

                return;
            }

            var p = 100 * (clientWidth / 375);

            document.documentElement.style.fontSize = p+'px'

            this.fontSize = p
        },
        toApp() {

        },
        toHome() {
            this.$router.push({
                path: "/index"
            });
        }
    },
    mounted() {
        if(this.isPhone){
            this.recalc()
        }
    },
    created() {
        this.idstring = this.$route.params.idstring
        this.isLogin = common.checkLogin();
        this.checkEncrypr()
        if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
            console.log(999)
            this.isPhone = true
        } else {
            this.isPhone = false
        }
        // this.getDetail()
    }
}
</script>

<style lang="less" scoped>
    .share-container {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100vh;
        min-width: 1080px;
        min-height: 720px;
        background: url(../../assets/img/login/login_bg.png) top/cover no-repeat;
        overflow-y: hidden;
        position: relative;

        &.on {
            background: #EEF2F3;
            margin: 0 !important;
            padding: 0 !important;
            min-height: 100vh;
            min-width: 100%;
            height: 100vh;
            justify-content: flex-start;
        }

        .pc {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .mob {
            position: relative;
            display: flex;
            flex-direction: column;
            width: 100%;
            // height: 6.67rem;
            // background: #EEF2F3;

            &>.head {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin: 0.76rem auto 0.37rem;

                img {
                    width: 0.75rem;
                    height: 0.75rem;
                    border-radius: 50%;
                    margin-bottom: 0.1rem;
                }

                p {
                    font-size: 0.15rem;
                    line-height: 0.21rem;
                    color: #050F0F; 
                    font-weight: bold;
                }
            }

            .input {
                display: flex;
                flex-direction: row;
                width: 100%;
                height: 0.58rem;
                background: #FFF;
                padding: 0 0.35rem;
                box-sizing: border-box;

                input {
                    width: 100%;
                    height: 100%;
                }
            }

            .btn {
                width: 3.05rem;
                height: 0.49rem;
                line-height: 0.49rem;
                text-align: center;
                background: #41B48C;
                box-shadow: 0px 0.075rem 0.22rem 0px rgba(37, 35, 37, 0.1);
                border-radius: 0.03rem;
                font-size: 0.17rem;
                color: #FFFFFF;
                margin: 0.28rem auto 0;
            }

            .err-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                .left {
                    width: 1.37rem;
                    height: 0.9rem;
                    background: url('../../assets/img/common/error.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-top: 1.06rem;
                    // margin-right: 46px;
                }

                .right {
                    display: flex;
                    flex-direction: column;

                    .title {
                        font-size: 0.15rem;
                        line-height: 0.21rem;
                        color: #050F0F;
                        font-weight: bold;
                        margin-bottom: 0.28rem;
                        text-align: center;
                    }

                    .content {
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 0.15rem !important;
                        background: transparent !important;
                        box-shadow: none;
                        margin-top: 0 !important;

                        span {
                            display: block;
                            font-size: 0.12rem;
                            line-height: 0.16rem;
                            color: #050F0F;
                            margin-bottom: 0.05rem;
                            text-align: center;
                        }

                        p {
                            font-size: 0.12rem;
                            line-height: 0.2rem;
                            color: #050F0F;
                            text-align: center;
                        }
                    }

                    .href {
                        font-size: 0.12rem;
                        line-height: 0.16rem;
                        color: #41B48C;
                        user-select: none;
                        cursor: pointer;
                        text-align: center;
                    }
                }
            }

            .content {
                // position: relative;
                width: 3.45rem;
                margin: 0.6rem auto 0;
                padding: 0.1rem 0.25rem;
                box-sizing: border-box;
                background: #FFFFFF;
                box-shadow: 0.02rem 0.02rem 0.05rem 0px rgba(5, 10, 15, 0.05);
                border-radius: 0.02rem;

                .detail {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .head {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        width: 100%;
                        margin-bottom: 0.1rem;
                        box-sizing: border-box;

                        img {
                            width: 0.335rem;
                            height: 0.335rem;
                            border-radius: 50%;
                            margin-right: 0.09rem;
                        }

                        p {
                            flex: 1;
                            overflow: hidden;
                            text-overflow:ellipsis;
                            white-space: nowrap;
                            font-size: 0.13rem;
                            // margin: 0 !important;
                        }
                    }

                    .line {
                        border-bottom: 1px solid #E2E6E6;
                        box-sizing: border-box;
                        margin-bottom: 0.11rem;
                    }

                    &>.title {
                        width: 100%;
                        overflow: hidden;
                        text-overflow:ellipsis;
                        white-space: nowrap;
                        font-size: 0.15rem;
                        line-height: 0.21rem;
                        font-weight: bold;
                        color: #050F0F;
                        margin-bottom: 0.12rem;
                    }

                    .media {
                        position: relative;
                        width: 100%;
                        height: 1.66rem;
                        border-radius: 0.02rem;
                        margin-bottom: 0.2rem;

                        .pic {
                        width: 100%;
                        height: 100%;
                        background-repeat: no-repeat;
                        background-position: center center;
                        background-size: contain;
                    }

                    .video {
                        position: relative;
                        width: 100%;
                        height: 100%;

                        video {
                            width: 100%;
                            height: 100%;
                        }

                        .speedRate {
                            position: absolute;
                            top: -0.1rem;
                            right: 0.03rem;
                            z-index: 9999999;
                            margin: 0 !important;

                            .btn {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            width: 0.6rem;
                            height: 0.3rem;
                            border-radius: 0.7rem;
                            background: rgba(0, 0, 0, 0.3);
                            user-select: none;
                            cursor: pointer;

                            span {
                                display: block;
                                font-size: 16px;
                                line-height: 30px;
                                color: #fff;
                            }

                            img {
                                margin-left: 4px;
                            }
                            }

                            .btnList {
                            display: flex;
                            flex-direction: column;

                            p {
                                height: 10px;
                            }

                            ul {
                                display: flex;
                                flex-direction: column;
                                border-radius: 4px;
                                overflow: hidden;
                                background: rgba(0, 0, 0, 0.3);

                                li {
                                width: 100%;
                                height: 30px;
                                line-height: 30px;
                                text-align: center;
                                font-size: 16px;
                                color: #fff;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: rgba(0, 0, 0, 0.5);
                                }
                                }
                            }
                            }
                        }
                    }

                    .audio {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 100%;

                        audio {
                            display: none;
                        }

                        .control {
                            position: relative;
                            width: 1.44rem;
                            height: 1.44rem;
                            margin: 0 auto 0;
                            // padding-top: 84px;
                            box-sizing: border-box;
                            margin-bottom: 0px;

                            img {
                                &.disk {
                                    width: 144px;
                                    height: 144px;
                                }
                            }

                            .play {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -0.32rem;
                                margin-top: -0.42rem;
                                user-select: none;
                                cursor: pointer;
                            }

                            .pause {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -0.12rem;
                                margin-top: -0.2rem;
                                user-select: none;
                                cursor: pointer;
                            }
                        }

                        .progress-container {
                            display: flex;
                            flex-direction: column;
                            width: 100%;
                            // width: 392px;
                            // width: 598px;
                            // margin: 0 auto;

                            .time {
                            position: unset;
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-end;
                            font-size: 0.13rem;
                            line-height: 0.15rem;
                            color: #829191;
                            font-weight: bold;
                            font-family: Arial;
                            margin-bottom: 0.04rem;
                            background: transparent !important;

                            span {
                                display: block;
                                line-height: 0.32rem;
                            }

                            .grey {
                                color: #b9c3c3;
                            }
                            }

                            .progress {
                            position: relative;
                            width: 100%;
                            user-select: none;

                            .progress-bg {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 3px;
                                border-radius: 1.5px;
                                background-color: rgba(151, 151, 151, 0.2);
                            }

                            .progress-fill {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 0%;
                                height: 3px;
                                border-radius: 1.5px;
                                background-color: #41B48C;

                                i {
                                position: absolute;
                                top: 50%;
                                right: -7px;
                                margin-top: -7px;
                                display: block;
                                width: 14px;
                                height: 14px;
                                border-radius: 50%;
                                background: #75C6AA;
                                cursor: pointer;
                                }
                            }
                            }
                        }
                    }

                        .preview {
                            position: absolute;
                            bottom: 0.1rem;
                            right: 0.1rem;
                            width: 0.26rem;
                            height: 0.26rem;
                            user-select: none;
                            cursor: pointer;
                        }
                    }

                    .btns {
                        width: 100%;
                        display: flex;
                        flex-direction: column;
                        &>div {
                            position: relative;
                        }

                        p {
                            width: 100%;
                            height: 0.49rem;
                            line-height: 0.49rem;
                            text-align: center;
                            background: rgba(185, 195, 195, 0.2);
                            border-radius: 4px;
                            font-size: 0.15rem;
                            font-weight: bold;
                            color: #829191;
                            margin-bottom: 0.12rem;

                            &.green {
                                position: relative;
                                background: #41B48C;
                                color: #FFF;

                                ul {
                                    position: absolute;
                                    top: 0.59rem;
                                    left: 0;
                                    border-radius: 0.04rem;
                                    overflow: hidden;

                                    li {
                                        width: 2.95rem;
                                        height: 0.49rem;
                                        background: rgba(0, 0, 0, 0.8);
                                        color: #FFF !important;

                                        p {
                                            color: #FFF !important;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    .time1 {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 0.22rem;
                        line-height: 0.22rem;
                        text-align: center;
                        background: #FAE9B1;
                        color: #775A04;
                        font-size: 0.11rem;
                    }

                }
            }
        }

        .time {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 32px;
            line-height: 32px;
            background: #FFF3CB;
            font-size: 14px;
            color: #775A04;
            text-align: center;
        }

        .logo {
            // position: absolute;
            // top: 112px;
            // left: 50%;
            // margin-left: -100px;
            width: 200px;
            height: auto;
            margin-bottom: 75px;
        }

        .file-container {
            width: 720px;
            min-height: 302px;
            background: #FFFFFF;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 40px 80px;
            box-sizing: border-box;
            // margin-top: 75px;

            .title {
                font-size: 20px;
                line-height: 28px;
                color: #050F0F;
                font-weight: bold;
                text-align: center;
                margin-bottom: 30px;
            }

            .content {
                display: flex;
                flex-direction: column;

                .notice {
                    font-size: 14px;
                    line-height: 20px;
                    color: #050F0F;
                    margin-bottom: 16px;
                    font-weight: bold;
                }

                .input-container {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    width: 100%;
                    margin-bottom: 20px;

                    .input {
                        flex: 1;
                        height: 40px;
                        background: rgba(185, 195, 195, 0.2);
                        border-radius: 4px;
                        padding: 0 20px;
                        box-sizing: border-box;

                        input {
                            width: 100%;
                            height: 100%;
                            background: transparent;
                            font-size: 14px;
                            color: #050F0F;
                        }
                    }
                    .btn {
                        width: 120px;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                        background: #41B48C;
                        border-radius: 4px;
                        font-size: 14px;
                        color: #FFFFFF;
                        margin-left: 20px;
                        user-select: none;
                        cursor: pointer;
                        font-weight: bold;
                    }
                }

                .alert {
                    font-size: 14px;
                    line-height: 20px;
                    color: #FF555A;                  
                    font-weight: bold;
                }
            }
            .error-container {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;

                .left {
                    width: 174px;
                    height: 114px;
                    background: url('../../assets/img/common/error.png') no-repeat;
                    background-position: center center;
                    background-size: 100% 100%;
                    margin-right: 46px;
                }

                .right {
                    display: flex;
                    flex-direction: column;

                    .title {
                        font-size: 20px;
                        line-height: 28px;
                        color: #050F0F;
                        font-weight: bold;
                        margin-bottom: 20px;
                    }

                    .content {
                        display: flex;
                        flex-direction: column;
                        margin-bottom: 22px;

                        span {
                            display: block;
                            font-size: 14px;
                            line-height: 20px;
                            color: #050F0F;
                            margin-bottom: 8px;
                        }

                        p {
                            font-size: 14px;
                            line-height: 20px;
                            color: #050F0F;
                        }
                    }

                    .href {
                        font-size: 14px;
                        line-height: 20px;
                        color: #41B48C;
                        user-select: none;
                        cursor: pointer;
                    }
                }
            }
        }

        .detail-container {
            width: 528px;
            height: 475px;
            background: #FFFFFF;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            border-radius: 4px;
            padding: 16px 40px 30px;
            box-sizing: border-box;

            .title {
                display: flex;
                flex-direction: row;
                align-items: center;
                padding-bottom: 16px;
                box-sizing: border-box;

                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                }

                p {
                    font-size: 16px;
                    line-height: 22px;
                    color: #050F0F;
                    font-weight: 500;
                    margin-left: 10px;
                }
            }

            .line {
                width: 448px;
                border-bottom: 1px solid #E2E6E6;
                box-sizing: border-box;
                margin: 0 auto;
            }

            .content {
                display: flex;
                flex-direction: column;

                &>p {
                    font-size: 18px;
                    line-height: 25px;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    white-space: nowrap;
                    color: #050F0F;
                    font-weight: bold;
                    margin: 14px 0 15px;
                }

                .media {
                    position: relative;
                    width: 448px;
                    height: 252px;
                    border-radius: 4px;
                    overflow: hidden;
                    
                    .pic {
                        width: 100%;
                        height: 100%;
                        background-repeat: no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }

                    .video {
                        position: relative;
                        width: 100%;
                        height: 100%;

                        video {
                            width: 100%;
                            height: 100%;
                        }

                        .speedRate {
                            position: absolute;
                            top: 14px;
                            right: 14px;
                            z-index: 9999999;

                            .btn {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            width: 62px;
                            height: 30px;
                            border-radius: 15px;
                            background: rgba(0, 0, 0, 0.3);
                            user-select: none;
                            cursor: pointer;

                            span {
                                display: block;
                                font-size: 16px;
                                line-height: 30px;
                                color: #fff;
                            }

                            img {
                                margin-left: 4px;
                            }
                            }

                            .btnList {
                            display: flex;
                            flex-direction: column;

                            p {
                                height: 10px;
                            }

                            ul {
                                display: flex;
                                flex-direction: column;
                                border-radius: 4px;
                                overflow: hidden;
                                background: rgba(0, 0, 0, 0.3);

                                li {
                                width: 100%;
                                height: 30px;
                                line-height: 30px;
                                text-align: center;
                                font-size: 16px;
                                color: #fff;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: rgba(0, 0, 0, 0.5);
                                }
                                }
                            }
                            }
                        }
                    }

                    .audio {
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        width: 100%;
                        height: 100%;

                        audio {
                            display: none;
                        }

                        .control {
                            position: relative;
                            width: 144px;
                            margin: 0 auto 0;
                            // padding-top: 84px;
                            box-sizing: border-box;
                            margin-bottom: 0px;

                            img {
                                &.disk {
                                    width: 144px;
                                    height: 144px;
                                }
                            }

                            .play {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -32px;
                                margin-top: -42px;
                                user-select: none;
                                cursor: pointer;
                            }

                            .pause {
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                margin-left: -12px;
                                margin-top: -20px;
                                user-select: none;
                                cursor: pointer;
                            }
                        }

                        .progress-container {
                            position: relative;
                            display: flex;
                            flex-direction: column;
                            // width: 100%;
                            width: 392px;
                            // width: 598px;
                            margin: 0 auto;

                            .time {
                            position: unset;
                            background: none !important;
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-end;
                            font-size: 13px;
                            line-height: 15px;
                            color: #829191;
                            font-weight: bold;
                            font-family: Arial;
                            margin-bottom: 8px;

                            span {
                                display: block;
                                line-height: 32px;
                            }

                            .grey {
                                color: #b9c3c3;
                            }
                            }

                            .progress {
                            position: relative;
                            width: 100%;
                            user-select: none;

                            .progress-bg {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 100%;
                                height: 3px;
                                border-radius: 1.5px;
                                background-color: rgba(151, 151, 151, 0.2);
                            }

                            .progress-fill {
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: 0%;
                                height: 3px;
                                border-radius: 1.5px;
                                background-color: #41B48C;

                                i {
                                position: absolute;
                                top: 50%;
                                right: -7px;
                                margin-top: -7px;
                                display: block;
                                width: 14px;
                                height: 14px;
                                border-radius: 50%;
                                background: #75C6AA;
                                cursor: pointer;
                                }
                            }
                            }
                        }
                    }

                    .preview {
                        position: absolute;
                        bottom: 14px;
                        right: 14px;
                        width: 40px;
                        height: 40px;
                        user-select: none;
                        cursor: pointer;
                    }
                }
            }

            .btns {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                margin-top: 16px;

                div {
                    position: relative;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    width: 214px;
                    height: 40px;
                    background: rgba(185, 195, 195, 0.2);
                    border-radius: 4px;
                    user-select: none;
                    cursor: pointer;

                    span {
                        display: block;
                        font-size: 14px;
                        line-height: 20px;
                        color: #829191;
                        font-weight: bold;
                        margin-left: 4px;
                    }

                    img {
                        width: 18px;
                        height: 18px;
                    }

                    ul {
                        position: absolute;
                        top: 50px;
                        z-index: 99999999;
                        display: flex;
                        flex-direction: column;
                        padding: 7px 0;
                        box-sizing: border-box;
                        background: rgba(0, 0, 0, 0.8);
                        border-radius: 4px;
                        overflow: hidden;

                        li {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            width: 214px;
                            height: 40px;
                            font-size: 14px;
                            color: #FFFFFF;
                            font-weight: bold;
                            // padding-left: 20px;
                            box-sizing: border-box;

                            &:hover {
                            color: #41B48C;

                            &.k {
                                i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('../../common/newMaterialBox/assets/download/800kOn.svg') no-repeat;
                                background-size: 100% 100%;
                                background-position: center center;
                                margin-right: 10px;
                                }
                            }

                            &.hd {
                                i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('../../common/newMaterialBox/assets/download/hdOn.svg') no-repeat;
                                background-size: 100% 100%;
                                background-position: center center;
                                margin-right: 10px;
                                }
                            }
                            }

                            &.k {
                            i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('../../common/newMaterialBox/assets/download/800k.svg') no-repeat;
                                background-size: 100% 100%;
                                background-position: center center;
                                margin-right: 10px;
                            }
                            }

                            &.hd {
                            i {
                                display: block;
                                width: 20px;
                                height: 20px;
                                background: url('../../common/newMaterialBox/assets/download/hd.svg') no-repeat;
                                background-size: 100% 100%;
                                background-position: center center;
                                margin-right: 10px;
                            }
                            }
                        }
                        }

                    &.green {
                        position: relative;
                        background: #41B48C !important;
                        border-radius: 4px;

                        span {
                            font-size: 14px;
                            line-height: 20px;
                            color: #FFFFFF;
                            font-weight: bold;
                        }

                        ul {
                            position: absolute;
                            top: 50px;
                            // left: -27px;
                            z-index: 1;
                            display: flex;
                            flex-direction: column;
                            padding: 7px 0;
                            box-sizing: border-box;
                            background: rgba(0, 0, 0, 0.8);
                            border-radius: 4px;
                            overflow: hidden;

                            li {
                                display: flex;
                                flex-direction: row;
                                justify-content: center;
                                align-items: center;
                                width: 214px;
                                height: 40px;
                                font-size: 14px;
                                color: #FFFFFF;
                                font-weight: bold;
                                // padding-left: 20px;
                                box-sizing: border-box;

                                &:hover {
                                color: #41B48C;

                                &.clue {
                                    i {
                                    display: block;
                                    width: 20px;
                                    height: 20px;
                                    background: url('../../common/newMaterialBox/assets/create/clueOn.svg') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    margin-right: 10px;
                                    }
                                }

                                &.report {
                                    i {
                                    display: block;
                                    width: 20px;
                                    height: 20px;
                                    background: url('../../common/newMaterialBox/assets/create/reportOn.svg') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    margin-right: 10px;
                                    }
                                }

                                &.publish {
                                    i {
                                    display: block;
                                    width: 20px;
                                    height: 20px;
                                    background: url('../../common/newMaterialBox/assets/create/publishOn.svg') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    margin-right: 10px;
                                    }
                                }

                                &.newMediaPublic {
                                    i {
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        background: url("../../common/newMaterialBox/assets/create/newMediaIconOn.svg")
                                            no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 10px;
                                    }
                                }
                                }

                                &.clue {
                                i {
                                    display: block;
                                    width: 20px;
                                    height: 20px;
                                    background: url('../../common/newMaterialBox/assets/create/clue.svg') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    margin-right: 10px;
                                }
                                }

                                &.report {
                                i {
                                    display: block;
                                    width: 20px;
                                    height: 20px;
                                    background: url('../../common/newMaterialBox/assets/create/report.svg') no-repeat;
                                    background-size: 100% 100%;
                                    background-position: center center;
                                    margin-right: 10px;
                                }
                                }

                                &.publish {
                                    i {
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        background: url('../../common/newMaterialBox/assets/create/publish.svg') no-repeat;
                                        background-size: 100% 100%;
                                        background-position: center center;
                                        margin-right: 10px;
                                    }
                                }

                                &.newMediaPublic {
                                    i {
                                        display: block;
                                        width: 20px;
                                        height: 20px;
                                        background: url("../../common/newMaterialBox/assets/create/newMediaIcon.svg")
                                            no-repeat;
                                        background-position: center center;
                                        background-size: 100% 100%;
                                        margin-right: 10px;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        .statement {
            width: 250px;
            height: 17px;
            position: absolute;
            left: 50%;
            bottom: 30px;
            margin-left: -125px;
            line-height: 17px;
            text-align: center;
            font-size: 12px;
            color: #e6e6e6;
            text-align: center;
            text-shadow: 6px 6px 20px rgb(0 0 0 / 10%);
        }
    }
</style>